import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Accordion, AccordionRow, Radio } from '@paypalcorp/pp-react';
import Non3DsTestCards from './Non3DsTestCards';
import ThreeDsTestCards from './ThreeDsTestCards';
import styles from '../TestCards.module.less';
import { trackFieldFocus, trackFieldChange, trackFieldClosed } from '../../../../lib/fpti';

const TestCardsWrapper = ({ showRadioButtons = true }) => {
  const [isOpen, setOpen] = useState(false);
  const [radioState, setRadioState] = useState('Non3DS');
  const accordionRef = useRef(null);

  const handleChange = (e) => {
    trackFieldChange('Test Cards Option', e.target.value);
    setRadioState(e.target.value);
  };

  useEffect(() => {
    const accordionElement = accordionRef.current;
    const svgElement = accordionElement.querySelector('svg');
    if (svgElement) {
      svgElement.setAttribute('tabindex', '0');
    }
  }, []);

  return (
    <div ref={accordionRef} className={styles.test_cards_container}>
      <Accordion name="Cards" className={styles.test_cards_accordion}>
        <AccordionRow
          heading="Test Cards"
          isOpen={isOpen}
          contentClassName={classNames({ [styles.accordion_row_content]: isOpen }) || null}
          onClick={() => {
            setOpen(!isOpen);
            if (!isOpen) {
              trackFieldFocus('Test Cards');
            } else {
              trackFieldClosed('Test Cards');
            }
          }}
        >
          {isOpen &&
            (showRadioButtons ? (
              <div className={styles.radio_buttons_toggle}>
                <Radio
                  id="non3dsRadio"
                  name="testCardsRadio"
                  value="Non3DS"
                  labelClassName={styles.radio_button_header}
                  label="Non 3DS Test Cards"
                  checked={radioState === 'Non3DS'}
                  onChange={handleChange}
                />
                <Radio
                  id="3dsRadio"
                  name="testCardsRadio"
                  value="3DS"
                  labelClassName={styles.radio_button_header}
                  label="3DS Test Cards"
                  checked={radioState === '3DS'}
                  onChange={handleChange}
                />
              </div>
            ) : (
              <div className={`${styles.radio_buttons_toggle} ${styles.header_toggle}`} />
            ))}
          {radioState === 'Non3DS' ? <Non3DsTestCards /> : <ThreeDsTestCards />}
        </AccordionRow>
      </Accordion>
    </div>
  );
};

TestCardsWrapper.propTypes = {
  showRadioButtons: PropTypes.bool.isRequired
};

export default TestCardsWrapper;
